import React, { Component } from "react";

// Real slides
const successImages = [
  "/img/successful/success1.png",
  "/img/successful/success2.png",
  "/img/successful/success3.png",
];

export class Contact extends Component {
  constructor(props) {
    super(props);
    // Start at 1 because we render [cloneLast, ...slides, cloneFirst]
    this.state = { currentIndex: 1, animate: true };
    this.rafId = null;
  }

  componentDidMount() {
    // 6 seconds between slides (dwell time). Slide anim ~0.7s.
    this.slideshowInterval = setInterval(this.nextSlide, 6000);
  }

  componentWillUnmount() {
    clearInterval(this.slideshowInterval);
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  nextSlide = () => {
    this.setState(prev => ({ currentIndex: prev.currentIndex + 1, animate: true }));
  };

  handleTransitionEnd = () => {
    const total = successImages.length;      // real slides
    const loopedLength = total + 2;          // [cloneLast, ...slides, cloneFirst]
    const { currentIndex } = this.state;

    if (currentIndex === loopedLength - 1) {
      // Moved onto clone of first -> snap back to real first (index 1)
      this.snapTo(1);
    } else if (currentIndex === 0) {
      // (only needed if you add prev navigation) clone of last -> snap to real last
      this.snapTo(total);
    }
  };

  snapTo = (index) => {
    this.setState({ animate: false, currentIndex: index }, () => {
      this.rafId = requestAnimationFrame(() => this.setState({ animate: true }));
    });
  };

  render() {
    const { currentIndex, animate } = this.state;

    // Build looped slides: [cloneLast, ...real, cloneFirst]
    const looped = [
      successImages[successImages.length - 1],
      ...successImages,
      successImages[0],
    ];
    const n = looped.length;

    // Compute offset as % of the track (track width = n * slideWidth)
    const offsetPct = (currentIndex * 100) / n;

    return (
      <div>
        {/* ✅ Client Success Stories (right-to-left infinite slider) */}
        <section
          className="full-bleed"
          style={{
            padding: "60px 20px 40px",
            textAlign: "center",
            background: "linear-gradient(to right, #17569b, #5ca9fb)",
            color: "white",
          }}
        >
          <h2 style={{ fontSize: "28px", marginBottom: "14px" }}>
            📸 Client Success Stories
          </h2>
          <p style={{ opacity: 0.95, marginBottom: 16 }}>
            Real results for Canadian small businesses — organized books, accurate filings, and money saved.
          </p>

          {/* Viewport */}
          <div
            style={{
              width: "100%",
              maxWidth: 700,
              margin: "0 auto",
              borderRadius: 8,
              boxShadow: "0 6px 16px rgba(0,0,0,.25)",
              overflow: "hidden",
            }}
          >
            {/* Track */}
            <div
              onTransitionEnd={this.handleTransitionEnd}
              style={{
                display: "flex",
                width: `${n * 100}%`,                     // total width
                transform: `translateX(-${offsetPct}%)`,  // move by a fraction of track
                transition: animate ? "transform 0.7s ease-in-out" : "none",
              }}
            >
              {looped.map((src, i) => (
                <div
                  key={`${src}-${i}`}
                  style={{
                    width: `${100 / n}%`,   // each slide takes equal fraction of track
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={src}
                    alt={`Client success slide`}
                    style={{
                      display: "block",
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 👇 Contact Section */}
        <div
          id="contact"
          style={{
            background: "linear-gradient(to right, #17569b, #5ca9fb)",
            color: "white",
            padding: "100px 0 60px",
            marginTop: 0,
          }}
        >
          <div className="container">
            <div className="row">
              {/* Left: Form */}
              <div className="col-md-8">
                <div className="section-title">
                  <h2
  style={{
    fontSize: "34px",
    fontWeight: 800,
    textTransform: "uppercase",
    color: "#fff",
    letterSpacing: "0.5px",
    marginBottom: "10px",
    textShadow:
      "-2px -2px 3px #000, 2px -2px 3px #000, -2px 2px 3px #000, 2px 2px 3px #000",
  }}
>
  REQUEST YOUR FREE QUOTE
</h2>

<p
  style={{
    marginBottom: 6,
    color: "#f0f0f0",
    fontSize: "17px",
    textShadow: "0 0 3px rgba(0,0,0,0.5)",
  }}
>
  Fill out the form and receive a response within{" "}
  <strong>24 hours</strong> — usually the same day.
</p>
<p
  style={{
    color: "#f0f0f0",
    marginBottom: 18,
    fontSize: "17px",
    textShadow: "0 0 3px rgba(0,0,0,0.5)",
  }}
>
  Secure & confidential. No hidden fees.
</p>

                </div>

                <form name="sentMessage" id="contactForm" noValidate>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          placeholder="Name"
                          required
                          aria-label="Your name"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Email"
                          required
                          aria-label="Your email"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="tel"
                          id="phone"
                          className="form-control"
                          placeholder="Phone (optional)"
                          aria-label="Your phone number"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <select
                          id="service"
                          className="form-control"
                          aria-label="Service type"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Select a service (optional)
                          </option>
                          <option value="t2">T2 Corporate Tax Filing</option>
                          <option value="gst">GST/HST Filing</option>
                          <option value="bk">Bookkeeping</option>
                          <option value="fs">Year-End Financial Statements</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Tell us what you need help with"
                      required
                      aria-label="Your message"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-custom btn-lg"
                    aria-label="Get my free quote"
                  >
                    Get My Free Quote
                  </button>

                  <div
                    className="no-solicit"
                    style={{
                      marginTop: 12,
                      fontSize: 12,
                      color: "white",
                    }}
                  >
                    🚫 No sales or solicitation. Business inquiries only.
                  </div>
                </form>
              </div>

             {/* Right: Info */}
<div
  className="col-md-3 col-md-offset-1 contact-info"
  style={{
    color: "#333",
    lineHeight: "1.8",
    fontSize: "16px",
    fontWeight: 500,
    background: "rgba(255,255,255,0.95)",
    borderRadius: "10px",
    padding: "22px 24px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
  }}
>
  <div className="contact-item">
    <h3 style={{ color: "#17569b", marginBottom: "12px" }}>Contact Info</h3>

{/* Compact embedded map */}
<div
  style={{
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    marginBottom: 12,
  }}
>
  <iframe
    src="https://www.google.com/maps?q=Ottawa,+ON&output=embed"
    title="Map - Ottawa, ON"
    width="100%"
    height="160"
    style={{ border: 0, display: "block", borderRadius: "6px" }}
    loading="lazy"
    allowFullScreen=""
    referrerPolicy="no-referrer-when-downgrade"
  />
</div>
<div style={{ textAlign: "center", marginTop: -4, marginBottom: 10 }}>
  <a
    href="https://maps.app.goo.gl/y1m6aDc4Te68833Y6"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#17569b", textDecoration: "underline" }}
  >
    Open in Google Maps
  </a>
</div>


    {/* Address / Phone / Email */}
    <p>
      <i className="fa fa-map-marker" style={{ color: "#17569b" }}></i>{" "}
      {this.props.data ? this.props.data.address : "Ottawa, ON, Canada"}
    </p>
    <p>
      <i className="fa fa-phone" style={{ color: "#17569b" }}></i>{" "}
      <a href="tel:+16138176185" style={{ color: "#17569b", textDecoration: "none" }}>
        (613) 817-6185
      </a>
    </p>
    <p>
      <i className="fa fa-envelope" style={{ color: "#17569b" }}></i>{" "}
      <a
        href="mailto:fasolutions2025@gmail.com"
        style={{ color: "#17569b", textDecoration: "none" }}
      >
        fasolutions2025@gmail.com
      </a>
    </p>
  </div>
</div>


            </div>
          </div>
        </div>

        {/* ✅ Seamless blue flow (no harsh break) */}
        <section
          className="full-bleed"
          style={{
            padding: "44px 20px",
            background: "linear-gradient(to right, #17569b, #5ca9fb)",
            color: "white",
            marginTop: 0,
          }}
        >
          <h2
            style={{
              fontSize: 22,
              marginBottom: 12,
              textTransform: "uppercase",
              letterSpacing: ".5px",
            }}
          >
            Corporate Tax & Bookkeeping — Ottawa • Toronto • Gatineau • Montreal
          </h2>

          <p
            style={{
              fontSize: 16,
              lineHeight: 1.7,
              maxWidth: 980,
              margin: "0 auto 16px",
            }}
          >
            FA Solutions helps incorporated businesses and professionals with{" "}
            <strong>T2 corporate tax returns</strong>,{" "}
            <strong>GST/HST filing & reconciliation</strong>, and{" "}
            <strong>bookkeeping</strong>. We serve clients locally and remotely across Canada with fast, accurate, and transparent service.
          </p>

          <div
            className="two-col"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 24,
              maxWidth: 980,
              margin: "0 auto",
            }}
          >
            <div>
              <h3 style={{ fontSize: 18, margin: "12px 0" }}>Popular services & searches</h3>
              <ul style={{ listStyle: "disc", paddingLeft: 22, lineHeight: 1.7, fontSize: 16 }}>
                <li><strong>T2 corporate tax filing</strong> (remote & local)</li>
                <li><strong>GST/HST filing</strong> and reconciliation</li>
                <li><strong>Monthly bookkeeping</strong> for small business</li>
                <li><strong>Year-end financial statements</strong></li>
                <li><strong>Prior-year corrections</strong> & adjustments</li>
              </ul>
            </div>
            <div>
              <h3 style={{ fontSize: 18, margin: "12px 0" }}>Cities we serve</h3>
              <ul style={{ listStyle: "disc", paddingLeft: 22, lineHeight: 1.7, fontSize: 16 }}>
                <li>Ottawa • Gatineau • Barrhaven • Orléans</li>
                <li>Toronto • Mississauga • Markham • Vaughan</li>
                <li>Montreal • Laval • Brossard</li>
                <li>Canada-wide remote corporate tax services</li>
              </ul>
            </div>
          </div>

          <p style={{ fontSize: 15, marginTop: 18, opacity: 0.95 }}>
            Looking for help?{" "}
            <a href="tel:+16138176185" style={{ color: "#fff", textDecoration: "underline" }}>
              Call now for a free consultation
            </a>{" "}
            or{" "}
            <a href="#contact" style={{ color: "#fff", textDecoration: "underline" }}>
              send us a message
            </a>.
          </p>
        </section>

        {/* Footer */}
        <div id="footer">
          <div className="container text-center">
            <p>© 2025 FA Solutions — Corporate Tax & Bookkeeping Services • Secure & Confidential Filing</p>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;

